import React, { useState, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaSearch,
  FaSpinner,
  FaInfoCircle,
  FaPaperPlane,
  FaComments,
  FaCaretDown,
} from "react-icons/fa";
import toast from "react-hot-toast";
import "react-datepicker/dist/react-datepicker.css";
import * as PartnerService from "../../Services/Partner/PartnerService";
import * as AccountService from "../../Services/Account/AccountService";
import { formatVisitDate } from "../../Common/CommonVariables";

import Popover from "../../Common/Popper";
import { parseISO } from "date-fns";
import { useLocation } from "react-router-dom";
// import "./PatientVisitComponent.css";
import CommonPagination from "../../Common/CommonPagination";
import PatientTestDetailsModalComponent from "../PatientVisit/PatientTestDetailsModalComponent";
import { format } from "date-fns";
import {
  useBulkPatientReportDownload,
  useDownloadPatientListExcelRights,
  useDownloadWOSReport,
  useDownloadWSReport,
  useRaiseComplaintRights,
} from "../../Common/CommonAccessFile";
import * as XLSX from "xlsx";
import RaiseComplaint from "../PartnerCase/RaiseComplaintModalComponent";
import { Eye } from "lucide-react";

const SalesAdminDashboardComponent = () => {
  const accessToDownloadReport = useBulkPatientReportDownload();
  const accessToDownloadWOSReport = useDownloadWOSReport();
  const accessToDownloadWSReport = useDownloadWSReport();
  useDownloadPatientListExcelRights();
  const accessToRaiseComplaintRights = useRaiseComplaintRights();

  const [patientReportList, setPatientReportList] = useState([]);

  // const selectedOrg = useSelector((state) => state.selectedOrganization);

  const [loading, setLoading] = useState(false);
  const [SearchLoading, setSearchLoading] = useState(false);
  const [reportFilter, setReportFilter] = useState("");

  const availableReports = patientReportList.filter(
    (rec) => rec.PP_ReportStatus__c === "AVAILABLE"
  );

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Set number of items per page

  //Pagination logic for available reports
  const indexOfLastAvailable = currentPage * itemsPerPage;
  const indexOfFirstAvailable = indexOfLastAvailable - itemsPerPage;
  const currentAvailableReports = availableReports.slice(
    indexOfFirstAvailable,
    indexOfLastAvailable
  );

  // Pagination logic
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const filteredReports =
    reportFilter === "AVAILABLE"
      ? patientReportList.filter((r) => r.PP_ReportStatus__c === "AVAILABLE")
      : patientReportList.filter((rec) => {
          if (!reportFilter) return true;
          if (reportFilter === "Cancelled")
            return rec.MHL_Visit_Status__c === "Cancelled";
          return rec.PP_ReportStatus__c === reportFilter;
        });

  const currentPageReports = filteredReports.slice(indexOfFirst, indexOfLast);

  const [endDate, setEndDate] = useState(new Date());
  const [sendReportModalShow, setSendReportModalShow] = useState(false);

  const {
    register,
    formState: { errors },
    reset,
    handleSubmit,
  } = useForm();
  const [selectedPatient, setSelectedPatient] = useState([]);
  const [searchByVid, setSearchByVid] = useState("");

  const [showRaiseComplaintModal, setShowRaiseComplaintModal] = useState(false);
  const [selectedVID, setSelectedVID] = useState(null);

  const [showFilter, setShowFilter] = useState(false);

  const handleRaiseComplaint = () => {
    setShowRaiseComplaintModal(true);
  };

  const handleSendReportClick = (rec) => {
    //console.log("reportURL", patientReportList);
    setSelectedPatient(rec);
    setSendReportModalShow(true);
  };

  const location = useLocation();
  const { filter } = location.state || {};

  const [initDone, setInitDone] = useState(false);

  useEffect(() => {
    if (filter) {
      setReportFilter(filter);
    }
  }, [filter]);

  //   useEffect(() => {
  //     if (!initDone && location.state) {
  //       const {
  //         startDate: passedStartDate,
  //         endDate: passedEndDate,
  //         dateRangeOption: passedOption,
  //       } = location.state;

  //       if (passedStartDate && endDate) {
  //         setDateRangeOption(passedOption || "Custom");
  //         setStartDate(new Date(passedStartDate));
  //         setEndDate(new Date(passedEndDate));
  //         setInitDone(true); // Prevents re-running this logic
  //       }
  //     }
  //   }, [location.state, initDone]);

  const [showPatientTestTATModal, setshowPatientTestTATModal] = useState(false);

  const [patient, setPatient] = useState({});
  const [visit, setVisit] = useState({});
  const [samples, setSamples] = useState([]);
  const [tests, setTests] = useState([]);
  const [reportURL, setReportURL] = useState("");
  const [reportWOSURL, setReportWOSURL] = useState("");
  const [visitStatus, setVisitStatus] = useState("");
  const [crmVisitDetails, setCRMVisitDetails] = useState([]);

  const GetPatientTestDetailTAT = (data) => {
    setSearchLoading(true);
    setCRMVisitDetails(data);
    PartnerService.GetPatientTestsDetailsByVID(data.Name, data.MHL_OrgId__C)
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          setshowPatientTestTATModal(true);
          const response = data.Data;

          setPatient(response.PatientDemographics || {});
          setVisit(response.PatientVisitDetails || {});
          setSamples(response.SampleInfoList || []);
          setTests(response.TestOrderDetails || []);
          setReportURL(response.ReportS3URL || "");
          setReportWOSURL(response.ReportWOSS3URL || "");
          setVisitStatus(response.VisitStatus || "");

          // setPatientReportList(data.Data);
        } else {
          // setPatientReportList([])
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setSearchLoading(false));
  };

  const getUniversalPatientVistDetailForSales = () => {
    if (!searchByVid || !searchByVid.trim()) {
      toast.error("Please enter VID to search");
      return;
    }

    setSearchLoading(true);
    setCurrentPage(1);

    AccountService.GetUniversalPatientVistDetailForSales(searchByVid)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setPatientReportList(data.Data);
        } else {
          toast.error(data?.ResponseMessage);
          setPatientReportList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setSearchLoading(false));
  };

  const [selectedAvailableReports, setSelectedAvailableReports] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Handle individual row selection
  const handleCheckboxChange = (rec) => {
    //debugger;
    const exists = selectedAvailableReports.find((r) => r.Name === rec.Name);
    if (exists) {
      // Remove from selected
      const updated = selectedAvailableReports.filter(
        (r) => r.Name !== rec.Name
      );
      setSelectedAvailableReports(updated);
      setSelectAll(false); // Deselect 'Select All' if even one is unchecked
    } else {
      // Add with full structure
      const updated = [
        ...selectedAvailableReports,
        {
          Name: rec.Name,
          Patient_Name: rec.MHL_Patient_Name,
          ReportURl: rec.WS_Report__c,
          WOS_ReportURl: rec.WOS_Report__c,
        },
      ];
      setSelectedAvailableReports(updated);

      // If all available reports are now selected, enable 'Select All'
      const availableRecords = patientReportList.filter(
        (r) => r.PP_ReportStatus__c === "AVAILABLE"
      );
      if (updated.length === availableRecords.length) {
        setSelectAll(true);
      }
    }
  };

  // Handle select all toggle
  const handleSelectAll = () => {
    const availableRecords = patientReportList.filter(
      (rec) => rec.PP_ReportStatus__c === "AVAILABLE"
    );

    if (selectAll) {
      // Unselect all
      setSelectedAvailableReports([]);
    } else {
      // Select all available
      const selected = availableRecords.map((rec) => ({
        Name: rec.Name,
        Patient_Name: rec.MHL_Patient_Name,
        ReportURl: rec.WS_Report__c,
        WOS_ReportURl: rec.WOS_Report__c,
      }));
      setSelectedAvailableReports(selected);
    }
    setSelectAll(!selectAll);
  };

  // Check if a row is selected
  const isChecked = (Name) =>
    selectedAvailableReports.some((r) => r.Name === Name);

  const filterDropdownRef = useRef(null);

  useEffect(() => {
    if (!showFilter) return;

    const handleClickOutside = (event) => {
      if (
        filterDropdownRef.current &&
        !filterDropdownRef.current.contains(event.target)
      ) {
        setShowFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilter]);

  return (
    <>
      <div>
        <div className="d-flex justify-content-end">
          <div
            className="search-box patient-visit-search-box"
            style={{ position: "relative", width: "320px" }}
          >
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search VID"
                onChange={(e) => setSearchByVid(e.target.value)}
                //   ref={selectedSearchPR}
                style={{
                  paddingRight: "35px",
                  borderRadius: "5px",
                  border: "1px solid #ddd",
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    getUniversalPatientVistDetailForSales();
                  }
                }}
              />
              <button
                className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-box-search-btn"
                style={{
                  padding: "5px",
                  position: "absolute",
                  top: "0",
                  right: "0px",
                  height: "35px",
                  width: "45px",
                  borderTopLeftRadius: "0",
                  borderBottomLeftRadius: "0",
                }}
                onClick={getUniversalPatientVistDetailForSales}
                disabled={SearchLoading}
              >
                {SearchLoading ? (
                  <FaSpinner className="fa-spin" />
                ) : (
                  <FaSearch />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        {patientReportList.length > 0 && (
          <div>
            <div className="table-responsive">
              <table className="table table-bordered custom-table">
                <thead>
                  <tr>
                    {accessToDownloadReport &&
                      (accessToDownloadWOSReport ||
                        accessToDownloadWSReport) && (
                        <th style={{ width: "3%" }}>
                          <input
                            type="checkbox"
                            onChange={handleSelectAll}
                            checked={selectAll}
                            title="Select All AVAILABLE"
                          />
                        </th>
                      )}

                    <th style={{ width: "20%" }}> VID </th>
                    <th style={{ width: "8%" }}> VID Date </th>
                    <th style={{ width: "12%" }}> PID </th>
                    <th style={{ width: "16%" }}> Patient Name </th>
                    {/* <th style={{ width: "5%" }}> Doctor </th> */}
                    <th style={{ width: "15%" }}> Test Name </th>
                    <th style={{ width: "8%" }}> TAT </th>
                    {/* <th style={{ width: "10%" }}> Report Status </th> */}
                    <th
                      style={{
                        width: "13%",
                        position: "relative",
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <div
                          className="d-flex gap-1"
                        //   onClick={() => setShowFilter(!showFilter)}
                        //   style={{ cursor: "pointer" }}
                        >
                          <span>Report Status</span>
                          {/* <span style={{ position: "relative" }}>
                            <FaCaretDown
                              style={{
                                color: "white",
                                cursor: "pointer",
                                width: "16px",
                                height: "16px",
                              }}
                              title="Filter Report Status"
                            />
                          </span> */}
                        </div>
                      </div>
                    </th>

                    <th style={{ width: "10%" }}> Action </th>
                  </tr>
                </thead>
                <tbody
                  style={{ fontSize: "0.5rem" }}
                  className="patient-list-small-font"
                >
                  {(() => {
                    const filteredPageReports = currentPageReports;

                    if (filteredPageReports.length === 0) {
                      return (
                        <tr>
                          <td colSpan="11" className="text-center">
                            No Patient visits found
                          </td>
                        </tr>
                      );
                    }

                    return filteredPageReports.map((rec, index) => (
                      <tr className="patient-list-row" key={index}>
                        {accessToDownloadReport &&
                          (accessToDownloadWOSReport ||
                            accessToDownloadWSReport) && (
                            <td
                              style={{
                                textAlign: "center",
                                verticalAlign: "middle",
                              }}
                            >
                              {rec.PP_ReportStatus__c === "AVAILABLE" && (
                                <input
                                  type="checkbox"
                                  onChange={() => handleCheckboxChange(rec)}
                                  checked={isChecked(rec.Name)}
                                  title="Select to include in Report List"
                                />
                              )}
                            </td>
                          )}

                        {/* VID */}
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          <Popover
                            content={
                              <div style={{ textAlign: "left" }}>
                                <p>
                                  <strong>VID:</strong> {rec.Name || "-"}
                                </p>
                                <p>
                                  <strong>TRF ID:</strong>{" "}
                                  {rec.TRF_ID__c || "-"}
                                </p>
                              </div>
                            }
                          >
                            {/* Icon triggers popover */}
                            <FaInfoCircle
                              color="green"
                              size={13}
                              className="mb-1"
                              style={{ cursor: "pointer" }}
                            />{" "}
                            &nbsp;
                          </Popover>

                          {/* Display full Name */}
                          <strong>{rec.Name || "-"}</strong>
                          <br />

                          <small style={{ fontSize: "11px", color: "#555" }}>
                            {rec.TRF_ID__c}
                          </small>
                        </td>

                        <td>{formatVisitDate(rec.MHL_Visit_Date__c)}</td>

                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {rec.MHL_PID__c}{" "}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          <Popover
                            content={
                              <div style={{ textAlign: "left" }}>
                                <p>
                                  <strong>Patient Name:</strong>{" "}
                                  {rec.MHL_Patient_Name || "-"}
                                </p>
                              </div>
                            }
                          >
                            <span
                              style={{ cursor: "pointer", fontWeight: "700" }}
                            >
                              {rec.MHL_Patient_Name
                                ? rec.MHL_Patient_Name.length > 18
                                  ? `${rec.MHL_Patient_Name.substring(
                                      0,
                                      18
                                    )}...`
                                  : rec.MHL_Patient_Name
                                : "-"}
                            </span>
                          </Popover>

                          <br />

                          {rec.MHL_Patient_Gender || "-"}
                          {rec.MHL_Patient_DOB && (
                            <>
                              {" "}
                              |{" "}
                              {format(
                                parseISO(rec.MHL_Patient_DOB),
                                "dd-MMM-yyyy"
                              )}
                            </>
                          )}
                        </td>

                        <td
                          className="test-text-small"
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {rec?.MHL_Test_Details_List?.length === 1 && (
                            <>
                              {rec.MHL_Test_Details_List[0].MHL_TestName__c
                                .length > 30 ? (
                                <Popover
                                  content={
                                    <span>
                                      {
                                        rec.MHL_Test_Details_List[0]
                                          .MHL_TestName__c
                                      }
                                    </span>
                                  }
                                >
                                  <span style={{ cursor: "pointer" }}>
                                    {rec.MHL_Test_Details_List[0].MHL_TestName__c.substring(
                                      0,
                                      30
                                    )}
                                    ...
                                  </span>
                                </Popover>
                              ) : (
                                rec.MHL_Test_Details_List[0].MHL_TestName__c
                              )}
                            </>
                          )}

                          {rec.MHL_Test_Details_List?.length > 1 && (
                            <Popover
                              content={
                                <ul
                                  className="list-unstyled"
                                  style={{
                                    textAlign: "left",
                                    paddingLeft: "2px",
                                    margin: 0,
                                  }}
                                >
                                  {rec.MHL_Test_Details_List.map(
                                    (test, index) => (
                                      <li key={index}>
                                        {test.MHL_TestName__c}
                                      </li>
                                    )
                                  )}
                                </ul>
                              }
                            >
                              <span
                                style={{ marginLeft: "5px", cursor: "pointer" }}
                              >
                                {rec.MHL_Test_Details_List[0].MHL_TestName__c
                                  .length > 30
                                  ? `${rec.MHL_Test_Details_List[0].MHL_TestName__c.substring(
                                      0,
                                      30
                                    )}...`
                                  : rec.MHL_Test_Details_List[0]
                                      .MHL_TestName__c}
                                {` (+${rec.MHL_Test_Details_List.length - 1})`}
                              </span>
                            </Popover>
                          )}
                        </td>

                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {rec.MHL_Visit_Status__c === "Cancelled"
                            ? "N/A"
                            : rec.MHL_Test_TAT_Date || "-"}
                        </td>

                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {rec.PP_ReportStatus__c === "PENDING" ? (
                            <span
                              style={{
                                backgroundColor: "#fff3cd",
                                color: "#856404",
                                padding: "5px 10px",
                                borderRadius: "5px",
                                fontSize: "12px",
                                display: "inline-block",
                                minWidth: "80px",
                              }}
                            >
                              PENDING
                            </span>
                          ) : rec.PP_ReportStatus__c === "AVAILABLE" ? (
                            <span
                              style={{
                                backgroundColor: "#d4edda",
                                color: "#155724",
                                padding: "5px 10px",
                                borderRadius: "5px",
                                fontSize: "12px",
                                display: "inline-block",
                                minWidth: "80px",
                              }}
                            >
                              AVAILABLE
                            </span>
                          ) : (
                            <span
                              style={{
                                backgroundColor: "#f8d7da",
                                color: "#721c24",
                                padding: "5px 10px",
                                borderRadius: "5px",
                                fontSize: "12px",
                                display: "inline-block",
                                minWidth: "80px",
                              }}
                            >
                              {rec.PP_ReportStatus__c}
                            </span>
                          )}
                        </td>

                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-center gap-2">
                            <div className="d-flex gap-2 align-items-center">
                              <span
                                disabled={loading}
                                className="d-flex"
                                title="View Details"
                                style={{
                                  display: "inline-block",
                                  transition: "transform 0.2s",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                }}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.transform =
                                    "scale(1.2)")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.transform = "scale(1)")
                                }
                                onClick={() => {
                                  GetPatientTestDetailTAT(rec);
                                }}
                              >
                                <Eye style={{ color: "green" }} />
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ));
                  })()}
                </tbody>
              </table>
            </div>

            {/* {showFilter && (
                                <>
                                    <div className="filter-backdrop" onClick={() => setShowFilter(false)} />
        
                                    <div className="filter-dropdown" ref={filterDropdownRef}>
                                        {[
                                            "", // All option
                                            ...Array.from(
                                                new Set(
                                                    currentPatientReport.map(rec =>
                                                        rec.MHL_Visit_Status__c === "Cancelled"
                                                            ? "Cancelled"
                                                            : rec.PP_ReportStatus__c
                                                    )
                                                )
                                            )
                                        ].map((status) => (
                                            <div
                                                key={status}
                                                className={`filter-option ${reportFilter === status ? "selected" : ""}`}
                                                onClick={() => handleFilterClick(status)}
                                            >
                                                {status === "" ? "All" : status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )} */}

            {filteredReports.length > itemsPerPage && (
              <CommonPagination
                pageList={filteredReports}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
              />
            )}
          </div>
        )}
      </div>

      {showPatientTestTATModal && (
        <PatientTestDetailsModalComponent
          handlePatientTestTATClose={() => setshowPatientTestTATModal(false)}
          patient={patient}
          visit={visit}
          samples={samples}
          tests={tests}
          reportURL={reportURL}
          reportWOSURL={reportWOSURL}
          visitStatus={visitStatus}
          crmVisitDetails={crmVisitDetails}
        />
      )}
    </>
  );
};

export default SalesAdminDashboardComponent;
